import AddPark from './AddPark'
import SyncChip from './SyncChip'
import StateBlock from './StateBlock'
import type { ParkSummary } from '../lib/types'

interface Props {
  parks: ParkSummary[]
  loading: boolean
  error: string | null
  errorDetail: string | null
  onRetry: () => void
  onOpen: (slug: string) => void
}

export default function ParksOverview({ parks, loading, error, errorDetail, onRetry, onOpen }: Props) {
  // The header and "Park toevoegen" stay put in every state: an empty list is exactly when you need them.
  const body = loading ? (
    <StateBlock kind="loading" message="Parken laden…" />
  ) : error ? (
    <StateBlock kind="error" message={error} detail={errorDetail} onRetry={onRetry} />
  ) : parks.length === 0 ? (
    <StateBlock kind="empty" message="Nog geen parken. Maak er hieronder een aan of importeer er een met app:park:import." />
  ) : (
    <div className="table-wrap">
      <table>
        <thead>
          <tr>
            <th scope="col">Park</th>
            <th scope="col">Slug</th>
            <th scope="col" className="num">Plaatsen</th>
            <th scope="col" className="num">Velden</th>
            <th scope="col" className="num">Voorzieningen</th>
            <th scope="col">Plattegrond</th>
            <th scope="col">Koppelingen</th>
          </tr>
        </thead>
        <tbody>
          {parks.map((park) => (
            <tr key={park.slug}>
              <td>
                <button type="button" className="row-link" onClick={() => onOpen(park.slug)}>
                  {park.name}
                </button>
              </td>
              <td className="muted">{park.slug}</td>
              <td className="num">{park.unitCount}</td>
              <td className="num">{park.zoneCount}</td>
              <td className="num">{park.poiCount}</td>
              <td>{park.hasMap ? 'ja' : <span className="inline-error">ontbreekt</span>}</td>
              <td>
                {park.integrations.length === 0 ? (
                  <span className="muted small">geen koppeling</span>
                ) : (
                  <span className="chips">
                    {park.integrations.map((integration) => (
                      <SyncChip key={integration.id} integration={integration} />
                    ))}
                  </span>
                )}
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  )

  return (
    <>
      <div className="main-head">
        <div>
          <h1>Parken</h1>
          <p className="muted small">
            {parks.length === 0
              ? 'Klik een park om de kaart, plaatsen en koppelingen te beheren.'
              : `${parks.length} parken. Klik een park om de kaart, plaatsen en koppelingen te beheren.`}
          </p>
        </div>
      </div>
      {body}
      <div style={{ marginTop: '1rem' }}>
        <AddPark onCreated={onOpen} />
      </div>
    </>
  )
}
